import axios from "axios";

export const Api = axios.create({
  baseURL: "https://admin.houseofdhanushdhari.com/api",
  headers: {
    "Content-Type": "application/json",
  },
});


